import produce from "immer"
import { OkrKeyResult } from "server/models"

import { INCREASE_TO } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initOkrKeyResult: OkrKeyResult = {
    id: null,
    sessionId: null,
    objectiveId: null,
    title: "",
    description: "",
    type: INCREASE_TO,
    metricId: null,
    useCriticalTarget: false,
    targetNumber: null,
    criticalNumber: null,
    initialNumber: null,
    actualNumber: null,
    order: null,
    deadlineType: null,
    deadlineHard: null,
    deadlineSoft: null,
}

const initOkrKeyResultState: types.OkrKeyResultState = {
    keyResultList: {},
    keyResultIds: {},
    keyResultEdit: initOkrKeyResult,

    // to select parent key result
    keyResultListEdit: {},
    keyResultIdsEdit: [],

    // popup menu
    active: null,
    menuShow: false,
    menuTarget: null,
    showConfirmDelete: false,

    reloadEdit: true,
}

const okrKeyResultReducer = produce((
    draft: types.OkrKeyResultState = initOkrKeyResultState,
    action: ActionTypes = null,
): types.OkrKeyResultState => {
    switch (action.type) {
        case types.OKR_KEY_RESULT_LIST:
            draft.keyResultList = action.keyResultList
            return draft

        case types.OKR_KEY_RESULT_IDS:
            draft.keyResultIds = action.keyResultIds
            return draft

        case types.OKR_KEY_RESULT_EDIT:
            draft.keyResultEdit = action.keyResult
            return draft


        // to select parent key result
        case types.OKR_KEY_RESULT_LIST_EDIT:
            draft.keyResultListEdit = action.keyResultList
            return draft

        case types.OKR_KEY_RESULT_IDS_EDIT:
            draft.keyResultIdsEdit = action.keyResultIds
            return draft


        // popup menu
        case types.OKR_KEY_RESULT_ACTIVE:
            draft.active = action.active
            return draft

        case types.OKR_KEY_RESULT_POPUP_MENU_SHOW:
            draft.menuShow = action.show
            return draft

        case types.OKR_KEY_RESULT_POPUP_MENU_TARGET:
            draft.menuTarget = action.target
            return draft

        case types.OKR_KEY_RESULT_SHOW_CONFIRM_DELETE:
            draft.showConfirmDelete = action.show
            return draft


        case types.OKR_KEY_RESULT_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default okrKeyResultReducer
